export default function MigrationProgressBar({ progress }) {
  return (
    <div className="migration-progress">
      <div
        className="migration-progress-fill"
        style={{
          width: `${progress}%`,
          transition: "width 0.3s ease"
        }}
      />
    </div>
  );
}
